import { getSectionByKey } from '@/services/siteSections';

// Logo por defecto como fallback (el nuevo logo subido por el admin)
const DEFAULT_LOGO_URL = 'https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/087e082e330e8397f7455cc656f090bf.png';

let cachedLogoUrl: string | null = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

// Deduplicación de la petición en vuelo: si varios componentes piden el logo
// al mismo tiempo (header + modal + layout), se reutiliza la misma consulta.
let inFlightLogoRequest: Promise<string> | null = null;

/**
 * Obtiene la URL del logo de la empresa desde la sección hero de site_sections.
 * Usa caché de 5 minutos para evitar consultas repetitivas.
 * Si falla o no hay logo configurado, devuelve el logo por defecto.
 */
export async function getCompanyLogoUrl(): Promise<string> {
  const now = Date.now();
  if (cachedLogoUrl && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedLogoUrl;
  }

  if (inFlightLogoRequest) {
    return inFlightLogoRequest;
  }

  inFlightLogoRequest = (async () => {
    try {
      const heroSection = await getSectionByKey('hero');
      if (heroSection?.content_json?.logo && typeof heroSection.content_json.logo === 'string' && heroSection.content_json.logo.trim() !== '') {
        cachedLogoUrl = heroSection.content_json.logo;
        cacheTimestamp = Date.now();
        return cachedLogoUrl;
      }
    } catch (error) {
      console.error('Error obteniendo logo desde site_sections:', error);
    }

    cachedLogoUrl = DEFAULT_LOGO_URL;
    cacheTimestamp = Date.now();
    return DEFAULT_LOGO_URL;
  })();

  try {
    return await inFlightLogoRequest;
  } finally {
    inFlightLogoRequest = null;
  }
}

/**
 * Invalida la caché del logo (llamar después de actualizar el logo en admin)
 */
export function invalidateLogoCache(): void {
  cachedLogoUrl = null;
  cacheTimestamp = 0;
  inFlightLogoRequest = null;
}